import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { urls } from "../../../urls";
import { getCatchError } from "../../../getCatchError";

const setGetUserById = (id) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                method: 'get',
                url: urls.GET_USER(id)
            });

            if (data.status === 'success') {
                dispatch(Action.Users.SetGetUserAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUserById as SetGetUserById
}